import LocalizedStrings from "react-localization";
import localization from "localization/register.json";
import { useLanguageContext } from "contexts/Localization";

export default function useTranslation() {
    // @ts-ignore
    const { language } = useLanguageContext();
    let translation = new LocalizedStrings(localization);

    translation.setLanguage(language);
    return translation;
}